import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { FinancingDetails } from './financingDetails';
import { Sponsor } from './sponsor';

@Injectable()
export class FinanceStudyService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getSponsorDetails(personId: string): Observable<Sponsor> {
    let url = this.urlSignature.sponsorDetailsUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Sponsor));
  }

  getFinancingDetails(personId: string): Observable<FinancingDetails[]> {
    let url = this.urlSignature.financingDetailsUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as FinancingDetails[]));
  }

  saveFinancingDetails(financeOption: FinancingDetails) {
    let url = this.urlSignature.financingDetailsUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data = JSON.stringify(financeOption);
    return this.httpClient
      .post(url, data, httpOptions)
      .pipe(map((response) => response as Response));
  }
}
